

<template>
    <label class="switch">
        <input class="switch-input" :disabled="disabled" @change="$emit('change', currentValue)" type="checkbox" v-model="currentValue">
        <span class="switch-core"></span>
        <div class="switch-label">
            <slot></slot>
        </div>
    </label>
</template>

<script>
/**
 * mt-switch
 * @module components/switch
 * @desc 切换按钮
 * @param {boolean} [value] - 绑定值，支持双向绑定
 * @param {slot} - 显示内容
 *
 * @example
 * <mt-switch v-model="value"></mt-switch>
 */
export default {
    name: "catSwitch",
    props: {
        value: Boolean,
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        currentValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../style/function.scss";
@import "../../style/config.scss";

.switch {
    display: flex;
    align-items: center;
    position: relative;
    * {
        pointer-events: none;
    }

    .switch-label {
        margin-left: 10px;
        display: inline-block;
        &:empty {
            margin-left: 0;
        }
    }

    .switch-core {
        display: inline-block;
        position: relative;
        width: 1rem;
        height: 0.56rem;
        border-radius: 0.28rem;
        background: #d9d9d9;

        &::after,
        &::before {
            content: " ";
            top: 0.02rem;
            left: 0.02rem;
            position: absolute;
            transition: transform 0.3s;
            border-radius: 0.26rem;
        }
        &::after {
            width: 0.52rem;
            height: 0.52rem;
            background-color: #fff;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
            transform: translateX(0.01rem);
        }
        &::before {
            width: 1rem;
            height: 0.56rem;
            // background-color: #fdfdfd;
        }
    }

    .switch-input {
        display: none;
        &:checked {
            & + .switch-core {
                border-color: #ffb600;
                background-color: #ffb600;
                &::before {
                    transform: scale(0);
                }
                &::after {
                    transform: translateX(0.44rem);
                }
            }
        }
    }
}
</style>
